import { useState, useEffect, useMemo } from "react";

import orionAPI from "../config/orionAPI";

export const formatNumber = (value, decimals = 2) =>
  (Number(value) || 0).toFixed(decimals);

export const formatPercentage = (value) => `${formatNumber(value, 2)}%`;

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `${day}/${month}/${year}`;
};

export const calculateOpenTime = (buyDate) => {
  if (!buyDate) return 0;
  const buyDateFormatted = new Date(buyDate.split(" ")[0]);
  const currentDate = new Date();
  return Math.floor((currentDate - buyDateFormatted) / (1000 * 60 * 60 * 24));
};

const useOpenStrategies = () => {
  const [rawOpenStrategies, setRawOpenStrategies] = useState([]);
  const [loadingOpenStrategies, setLoadingOpenStrategies] = useState(true);

  const openStrategies = useMemo(() => {
    if (!rawOpenStrategies.length) return [];

    return rawOpenStrategies.map((strategy) => {
      const profitValue =
        strategy.profit_percentage || strategy.partial_profit || 0;
      const openTime = calculateOpenTime(strategy.last_candle_date);

      return {
        ...strategy,
        profit_percentage: profitValue,
        partial_profit: profitValue,
        open_time: openTime,
        formatted: {
          profit: formatPercentage(profitValue),
          profitNumber: formatNumber(profitValue, 2),
          date: formatDate(strategy.last_candle_date),
          purchaseDate: formatDate(
            strategy.purchase_date || strategy.last_candle_date,
          ),
          buyValue: formatNumber(strategy.last_close, 8),
          currentValue: formatNumber(strategy.current_price, 8),
          openTimeDays: openTime > 1 ? `${openTime} dias` : `${openTime} dia`,
        },
      };
    });
  }, [rawOpenStrategies]);

  const fetchOpenStrategies = async () => {
    setLoadingOpenStrategies(true);
    await orionAPI
      .get("/api/dashboard/position_trade/open_trades")
      .then((response) => {
        setRawOpenStrategies(response.data);
        setLoadingOpenStrategies(false);
      })
      .catch((error) => {
        console.error(error);
        setLoadingOpenStrategies(false);
      });
  };

  useEffect(() => {
    fetchOpenStrategies();
  }, []);

  return {
    openStrategies,
    loadingOpenStrategies,
  };
};

export default useOpenStrategies;
